<template>
  <div class="ProjectPersonCom">
    <div
      class="top"
    >
      <div class="projectCountDesc ellipsis" :style="`font-size: ${pdescFontSize}px;`">场内人数</div>
      <div class="projectCountNum ellipsis" :style="`font-size: ${pnumFontSize}px;`">{{ personData.entryPersonAmount }}</div>
    </div>
    <div
      class="bottom"
    >
      <div class="itemWrapping">
        <div class="item">
          <div class="desc ellipsis" :style="`font-size: ${descFontSize}px;`">场内工人</div>
          <div class="num ellipsis" :style="`font-size: ${numFontSize}px;`">{{ personData.entryWorkerCount }}</div>
        </div>
        <div class="item">
          <div class="desc ellipsis" :style="`font-size: ${descFontSize}px;`">场内管理人员</div>
          <div class="num ellipsis" :style="`font-size: ${numFontSize}px;`">{{ personData.entryManagerCount }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { changeDevicePixelRatio } from '@/utils/changeComponentsSizeWithScale'
import { personCount } from '@/api/screen'
export default {
  components: { },
  props: {
    personData: {
      type: Object,
      default: () => { return {} }
    },
    attendanceFactComType: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      projectItem: state => state.user.projectItem,
      canvasStyleData: (state) => state.compose.canvasStyleData
    }),
    pdescFontSize() {
      const px = Math.ceil(16 / window.devicePixelRatio)
      return px
    },
    pnumFontSize() {
      const px = Math.ceil(50 / window.devicePixelRatio)
      return px
    },
    descFontSize() {
      const px = Math.ceil(15 / window.devicePixelRatio)
      return px
    },
    numFontSize() {
      const px = Math.ceil(30 / window.devicePixelRatio)
      return px
    }
  },

  created() {
    if (this.attendanceFactComType === 1) {
      this.personCount()
    }
  },

  methods: {
    changeDevicePixelRatio,
    personCount() {
      const form = { projectId: this.projectItem.projectId }
      if (this.attendanceFactComType === 1) {
        form.areaId = this.canvasStyleData.areaId
      } else {
        form.areaId = this.areaId
      }
      personCount(form).then((res) => {
        this.personData = res.data
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.ProjectPersonCom {
  width: 300px;
  height: 240px;
  color: #fff;

  .top{

                height: 45%;
                padding-top: 6%;
    text-align: center;

    color: #ffff00;
    .projectCountDesc{
      padding: 2% 4%;
      line-height: 1;
    }
    .projectCountNum{
      margin-top: 3%;
      padding: 0 4%;
      line-height: 1;
    }

  }
  .bottom{

    height: 55%;

    display: flex;
    .itemWrapping{
      width: 100%;
      display: flex;
      padding-top: 10%;
      .item{
        text-align: center;
        width: 50%;
        .desc{
          padding: 2% 4%;
          line-height: 1;
        }
        .num{
          margin-top: 12%;
          padding: 0 4%;
          line-height: 1;
        }
        &:first-child{
          color: #00ff36;
          .desc{
            position: relative;
            &::after{
              width: 2px;
              height: 100%;
              position: absolute;
              content: "";
              right: 0;
              top: 0;
              background: #fff;
            }
          }
          .num{
            position: relative;
            &::after{
              width: 2px;
              height: 100%;
              position: absolute;
              content: "";
              right: 0;
              top: 0;
              background: #fff;
            }
          }
        }
        &:last-child{
          color: #0099ff;
        }
      }
    }
  }

}
</style>
